import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {
	envAwareFormSubmit,
	envAwarePost
} from '../util/util'

export const getClientEmailTemplates = createAsyncThunk(
    'clientEmailsSlice/getClientEmailTemplates',
    async (payload) => await envAwarePost(
      'api/clientEmails/api/',
      {
        action:'getClientEmailTemplates', 
		...payload,
      }
    )
  )

  export const updateClientEmailTemplate = createAsyncThunk(
    'clientEmailsSlice/updateClientEmailTemplate',
    async (payload) => await envAwarePost(
      'api/clientEmails/api/',
      {
        action:'updateClientEmailTemplate', 
		...payload
      }
    )
  )

  export const restoreDefaultEmailTemplate = createAsyncThunk(
    'clientEmailsSlice/restoreDefaultEmailTemplate',
    async (payload) => await envAwarePost(
      'api/clientEmails/api/',
      {
        action:'restoreDefaultEmailTemplate', 
		...payload
      }
    )
  )


  

  

const clientEmailsSlice = createSlice({
	name: 'clientEmailsSlice',
	initialState: {
		welcomeEmail: [],
		isLoadingEmail: false,
	},
	reducers: {

	},
	extraReducers: {
		[getClientEmailTemplates.pending] : (state,action)=>{		
		state.isLoadingEmail = true;

	},
		[getClientEmailTemplates.fulfilled] : (state,action)=>{
		state.isLoadingEmail = false;
		const {success,data} = action.payload
		if (success == "1"){
			state.welcomeEmail = data.welcomeEmail;
		}
	}}
})

// Export the customized selectors for this adapter using `getSelectors`

export const { } = clientEmailsSlice.actions;


export default clientEmailsSlice.reducer